export const dataProjet = [
    {
        id: "1",
        img: "/img/ArgentBank.webp",
        title: "Argent Bank",
        title_des:
            "Implémenter le front-end d'une application bancaire avec React",
        description:
            "Développement du front-end d'une nouvelle banque en ligne avec React & Redux. Gestion des connexions utilisateurs et affichages de leurs comptes et transactions ainsi que la possiblité de modifier leur pseudo. Le tout via des appels API. Création de nouvelles routes API pour la gestion des transactions.",
        skills: "Javascript | React | Sass | Redux | Swagger",
        github: "https://github.com/ModanDahdouh/Projet-11-OC.git",
    },
    {
        id: "2",
        img: "/img/Booki.webp",
        title: "Booki",
        title_des:
            "Créer la page d'accueil d'une agence de voyage avec HTML & CSS",
        img_des: "/img/BookiMaquette.png",
        description:
            "Création de la page d'accueil d'une agence de voyage. L’entreprise souhaite développer un site Internet qui permette aux usagers de trouver des hébergements et des activités dans la ville de leur choix. Site entièrement réalisé en Html et Css",
        skills: "HTML | CSS",
        github: "https://github.com/ModanDahdouh/Projet-3-OC.git",
    },
    {
        id: "3",
        img: "/img/OhMyFood.webp",
        title: "Ohmyfood",
        title_des:
            "Améliorer l'interface d'un site mobile avec des animations CSS",
        description:
            "Développement d'un site en mobile first qui répertorie les menus de restaurants gastronomiques. Style et animations réalisés avec Sass.",
        skills: "HTML | Sass",
        github: "https://github.com/ModanDahdouh/Projet-4-OC.git",
    },
    {
        id: "4",
        img: "/img/Kasa.webp",
        title: "Kasa",
        title_des:
            "Créer une application web de location immobilière avec React",
        description:
            "Refonte d'un site de location d'appartements. Intégration de React avec des composants et les différentes routes. Création d'animations CSS de menus déroulants. Mise en place de requêtes vers un fichier Json pour alimenter les différents contenus sur le site. Intégration du site de manière responsive.",
        skills: "Javascript | React | Sass",
        github: "https://github.com/ModanDahdouh/Projet-8-OC.git",
    },
    {
        id: "5",
        img: "/img/events.webp",
        title: "724events",
        title_des: "Débugger le site d'une agence d'événementiel",
        description:
            "Débogage d'un site implémenté avec React, en utilisant des tests unitaires et d'intégrations réalisés avec Jest. Ecriture d'un cahier de recette des différentes fonctionnalités du site.",
        skills: "Javascript | React | Sass | Jest",
        github: "https://github.com/ModanDahdouh/Projet-10-OC.git",
    },
    {
        id: "6",
        img: "/img/nina.webp",
        title: "Nina Carducci",
        title_des: "Optimisez le référencement d'un site web",
        description:
            "Optimisation du référencement (SEO) et des performances d’un site web existant. Analyse via Lighthouse et Wave, amélioration de la structure du code, de l’accessibilité et de la vitesse de chargement afin d’optimiser la visibilité du site",
        skills: "Lighthouse | Wave",
        github: "https://github.com/ModanDahdouh/Projet-9-OC.git",
    },
    {
        id: "7",
        img: "/img/sophie-bluel.png",
        title: "Sophie Bluel",
        title_des:
            "Création d’un site dynamique pour une architecte d’intérieur",
        description:
            "Développement front-end dynamique avec JavaScript : gestion des événements, manipulation du DOM, communication avec une API, page de connexion administrateur et modale d’upload de médias.",
        skills: "HTML | CSS | JavaScript | API",
        github: "https://github.com/ModanDahdouh/Projet-OC-6.git",
    },
    {
        id: "8",
        img: "/img/Mask-group.png",
        title: "Qwenta",
        title_des: "Planification du développement du site Menu Maker (SEO)",
        description:
            "Participation à la planification et à la gestion du projet web : rédaction des spécifications techniques, organisation des fonctionnalités en tâches, veille technologique et utilisation d’outils de gestion de projet (Notion, Kanban).",
        skills: "Gestion de projet | Spécifications techniques | Veille technologique",
        github: "",
    },
];
